// 配置路由文件

import {
    FileTextOutlined, HomeOutlined, UserOutlined, HistoryOutlined
} from '@ant-design/icons';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        title: '首页',
        route: '/index',
        icon: <HomeOutlined />,
    },
    // {
    //     title: '我的信息',
    //     route: '/index_my_info',
    //     icon: <UserOutlined />,
    // },
    {
        title: '举报记录',
        route: '/index_report_list',
        icon: <HistoryOutlined />,
    },
    {
        title: '举报详情',
        route: '/index_report_detail',
        icon: <HistoryOutlined />,
        para: 'id',
        hidden: true
    },
    // {
    //     title: '用户协议和详细规则',
    //     route: '/index_policy',
    //     icon: <FileTextOutlined />,
    //     hidden: true
    // },
    {
        title: '用户登录',
        route: '/index_login',
        icon: <HistoryOutlined />,
        para: 'type',
        hidden: true
    }
]